export default __webpack_public_path__ + "static/media/avg_Value.68b954d5.svg";